import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzHlwn70 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_70: Record<
  Exclude<PageIdWoofzHlwn70, PageIdWoofzHlwn70.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_PAGE_HLWN_70]: {
    id: PageId.SUBSCRIPTIONS_PAGE_HLWN_70,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_HLWN_70]: {
    id: PageId.CHAT_UPSELL_HLWN_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_HLWN_70]: {
    id: PageId.UPSELL_HLWN_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_HLWN_70]: {
    id: PageId.DOWNLOAD_HLWN_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
